/* Line canlı sayfalar (#bx: lagerforsaljning, omer2026koleksiyon) — yapışkan çip çubuğu + 250'den fazla ürün için ek sayfa yükleme.
   Kaynak: Line2026/Store-Tech/theme_live_pages/assets/line-live-bx.js */
(function(){
  var root=document.getElementById('bx'); if(!root) return;
  var hdr=document.querySelector('.section-header');
  var chips=root.querySelector('.bx-chips');
  var links=[].slice.call(root.querySelectorAll('.bx-chip'));
  var secs=links.map(function(a){return document.querySelector(a.getAttribute('href'));});
  function hdrBottom(){ if(!hdr) return 0; var r=hdr.getBoundingClientRect(); return Math.max(0,Math.round(r.bottom)); }
  function sync(){
    root.style.setProperty('--bx-top',hdrBottom()+'px');
    var y=hdrBottom()+(chips?chips.offsetHeight:0)+20, cur=-1;
    secs.forEach(function(s,i){ if(s && !s.hidden && s.getBoundingClientRect().top<=y) cur=i; });
    links.forEach(function(a,i){
      var on=i===cur; if(on!==a.classList.contains('on')){ a.classList.toggle('on',on);
        if(on){ var row=a.parentNode; row.scrollTo({left:a.offsetLeft-row.clientWidth/2+a.offsetWidth/2,behavior:'smooth'}); } }
    });
  }
  window.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync); sync();
  // kategori tıklaması: header + sticky çubuk yüksekliği kadar pay bırakarak kaydır
  root.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#bx-"]'); if(!a) return;
    var t=document.querySelector(a.getAttribute('href')); if(!t) return;
    e.preventDefault();
    var goingUp=t.getBoundingClientRect().top<0;
    var off=(chips?chips.offsetHeight:0)+12+(goingUp&&hdr?hdr.offsetHeight:0);
    window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-off,behavior:'smooth'});
    if(history.replaceState) history.replaceState(null,'',a.getAttribute('href'));
  });

  // Liquid tek seferde en fazla 250 ürün basar. Koleksiyon büyürse kalan sayfalar burada çekilip
  // kartlar ilgili bölüme eklenir, sıra ve sayılar yeniden hesaplanır.
  var pages=+root.getAttribute('data-pages')||1, sid=root.getAttribute('data-sid');
  function kr(ore){ return String(Math.floor(ore/100)).replace(/\B(?=(\d{3})+(?!\d))/g,' ')+':-'; }
  function each(sel,fn){ [].forEach.call(root.querySelectorAll(sel),fn); }
  function recount(){
    var total=0, min=0;
    each('.bx-gal',function(s){
      var g=s.querySelector('.bx-grid'); if(!g) return;
      var cs=[].slice.call(g.querySelectorAll('.bx-card'));
      cs.sort(function(a,b){ var x=a.getAttribute('data-k')||'', y=b.getAttribute('data-k')||''; return x<y?-1:x>y?1:0; });
      cs.forEach(function(c){ g.appendChild(c); var p=+c.getAttribute('data-p'); if(p>0&&(!min||p<min)) min=p; });
      var id=s.id.replace(/^bx-/,''), n=cs.length; total+=n;
      s.hidden=!n;
      each('[data-bx-cat="'+id+'"]',function(e){ e.hidden=!n; });
      each('[data-bx-n="'+id+'"]',function(e){ e.textContent=n+(e.getAttribute('data-bx-suffix')||''); });
    });
    each('.bx-tgrp',function(g){ g.hidden=!g.querySelector('.bx-tile:not([hidden])'); });
    if(window.lineTilesInit) window.lineTilesInit();
    each('[data-bx-total]',function(e){ e.textContent=total+(e.getAttribute('data-bx-suffix')||''); });
    if(min) each('[data-bx-min]',function(e){ e.textContent='från '+kr(min); });
    sync();
  }
  (function more(n){
    if(n>pages||!sid) return;
    var u=new URL(location.href); u.hash=''; u.searchParams.set('page',n); u.searchParams.set('section_id',sid);
    fetch(u.toString()).then(function(r){ return r.ok?r.text():Promise.reject(); }).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      [].forEach.call(doc.querySelectorAll('#bx .bx-gal'),function(s){
        var g=root.querySelector('#'+s.id+' .bx-grid'); if(!g) return;
        [].forEach.call(s.querySelectorAll('.bx-card'),function(c){ g.appendChild(document.importNode(c,true)); });
      });
      recount(); more(n+1);
    }).catch(function(){});
  })(2);
})();
